import { useState, useEffect, useRef } from "react";
import { FaBullseye, FaEye } from "react-icons/fa";
import "../styles/MissionVision.css";

const SKILLS = [
  { name: "Global Recruitment", value: 88 },
  { name: "Visa & Immigration", value: 94 },
  { name: "Career Counseling", value: 76 },
  { name: "HR Consulting", value: 82 },
];

const TABS = ["Our Skill", "Our Mission", "Our Vision"];

function SkillBar({ name, value, animate }) {
  const [count, setCount] = useState(0);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!animate) {
      setCount(0);
      setWidth(0);
      return;
    }
    const timeout = setTimeout(() => {
      setWidth(value);
      let current = 0;
      const step = value / 60;
      const timer = setInterval(() => {
        current = Math.min(current + step, value);
        setCount(Math.round(current));
        if (current >= value) clearInterval(timer);
      }, 18);
      return () => clearInterval(timer);
    }, 100);
    return () => clearTimeout(timeout);
  }, [animate, value]);

  return (
    <div className="mv-skill-item">
      <div className="mv-skill-header">
        <span className="mv-skill-name">{name}</span>
        <span className="mv-skill-pct">{count}%</span>
      </div>
      <div className="mv-skill-bar-bg">
        <div
          className="mv-skill-bar-fill"
          style={{ width: `${width}%` }}
        />
      </div>
    </div>
  );
}

export default function MissionVision() {
  const [activeTab, setActiveTab] = useState(0);
  const [animateBars, setAnimateBars] = useState(false);
  const sectionRef = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          setAnimateBars(true);
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const handleTabClick = (idx) => {
    setActiveTab(idx);
    if (idx === 0) {
      setAnimateBars(false);
      setTimeout(() => setAnimateBars(true), 50);
    }
  };

  return (
    <section className="mv-section" ref={sectionRef}>
      <div className="mv-container">
        {/* LEFT — Image Collage */}
        <div className="mv-collage">
          <div className="mv-img mv-img-main">
            <img
            src="/assets/hr8.jpg"
            alt="About Pragya"
            style={{ width: '100%', height: 380, objectFit: 'cover', filter: 'brightness(0.8)', display: 'block' }}
            loading="lazy"
          />
          </div>
          <div className="mv-img mv-img-bot-l">
           <img
            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=700&q=80"
            alt="About Pragya"
            style={{ width: '100%', height: 380, objectFit: 'cover', filter: 'brightness(0.8)', display: 'block' }}
            loading="lazy"
          />
          </div>
          {/* <div className="mv-badge">
            <span>Leading Business</span>
            <span>Consultant Since 1993</span>
          </div> */}
        </div>

        {/* RIGHT — Content */}
        <div className="mv-content">
          <div className="mv-tag">Our Foundation</div>
          <h2 className="mv-heading">
            Mission &amp; <em>Vision</em>
          </h2>
          <p className="mv-subtext">
            We empower individuals with global career opportunities and help
            organizations build strong, diverse teams — delivering excellence
            in every placement, every visa, every career counseling session.
          </p>

          {/* Tabs */}
          <div className="mv-tabs">
            {TABS.map((tab, idx) => (
              <button
                key={tab}
                className={`mv-tab${activeTab === idx ? " active" : ""}`}
                onClick={() => handleTabClick(idx)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Tab: Our Skill */}
          {activeTab === 0 && (
            <div className="mv-tab-panel">
              {SKILLS.map((skill, i) => (
                <SkillBar
                  key={skill.name}
                  name={skill.name}
                  value={skill.value}
                  animate={animateBars}
                />
              ))}
            </div>
          )}

          {/* Tab: Our Mission */}
          {activeTab === 1 && (
            <div className="mv-tab-panel mv-prose">
              <div className="mv-card-icon"><FaBullseye /></div>
              <h3>Our Mission</h3>
              <p>
                To empower individuals with global career opportunities while
                helping organizations build strong, diverse teams. We are
                committed to delivering excellence in every placement, every
                visa, every career counseling session — connecting talent with
                opportunity across borders.
              </p>
            </div>
          )}

          {/* Tab: Our Vision */}
          {activeTab === 2 && (
            <div className="mv-tab-panel mv-prose">
              <div className="mv-card-icon"><FaEye /></div>
              <h3>Our Vision</h3>
              <p>
                To become a leading global HR consultancy known for integrity,
                efficiency, and success. We envision a world where geography is
                no barrier to professional excellence and opportunity — where
                the right talent always finds the right place.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}